<template>
  <div
    :id="figId + '-wrapper'"
    class="fixed-grid min-width pointer-plus"
    :key="figId"
    :class="[figId]"
  >
    <figure :id="figId" class="c-1--1">
      <svg class="c-1--1" viewBox="0 0 1440 444">
        <defs>
          <path
            id="arrow-right-sign"
            d="M1058.002 323l-1.584-1.575 5.29-5.28H1048v-2.288h13.707l-5.29-5.272 1.584-1.584 8 8z"
          />
        </defs>
        <g>
          <g>
            <path
              fill-opacity="0.25"
              fill="#00baff"
              d="M1062 424h378V274h-378z"
            />
            <path
              fill-opacity="0.25"
              fill="#00baff"
              d="M0 424h1050V198H0zM1440 80v106h-235c-7.972 0-17.716 6.87-30 24.5s-14.336 22.53-31.384 37.024S1106.454 270 1083 270h-21v-72h21c6.165 0 12.067-2.462 20.544-12H0V80h1440z"
            />
          </g>
          <g class="anime-tl-low anime-opacity" data-opacity="0.5">
            <image
              x="302"
              y="74"
              width="265"
              height="248"
              href="@/assets/work/alibaba/content/iteration/low-login.png"
            />
            <text class="ali-evolution-text-body">
              <tspan x="219" y="112">Log In</tspan>
            </text>
            <image
              x="302"
              y="192"
              width="318"
              height="248"
              href="@/assets/work/alibaba/content/iteration/low-package.png"
            />
            <text class="ali-evolution-text-body">
              <tspan x="219" y="232">Package</tspan>
              <tspan x="219" dy="18">Folder</tspan>
            </text>

            <text class="ali-evolution-text-title">
              <tspan x="311" y="37">1ST DESIGN ITERATION (MID-FI)</tspan>
            </text>
          </g>
          <g class="anime-tl-mid anime-opacity" data-opacity="0.5">
            <!-- <image
              opacity="0"
              x="660"
              y="198"
              width="300"
              height="226"
              href="@/assets/work/alibaba/content/iteration/mid-interaction.png"
              class="anime-tl-mid anime-translate anime-opacity"
              data-dx="300"
              data-dy="0"
              data-opacity="1"
            />-->
            <image
              x="660"
              y="198"
              width="300"
              height="226"
              href="@/assets/work/alibaba/content/iteration/mid-package.png"
            />
            <text class="ali-evolution-text-body">
              <tspan x="680" y="148">Incorporate</tspan>
              <tspan x="680" dy="18">Visual Guides</tspan>
              <tspan x="680" dy="18">&amp; Iconset</tspan>
            </text>

            <text class="ali-evolution-text-title" text-anchor="middle">
              <tspan x="810" y="37">2ND DESIGN ITERATION</tspan>
            </text>
          </g>
          <g class="anime-tl-hi anime-opacity" data-opacity="0.5">
            <g fill="#00baff">
              <use href="#arrow-right-sign" x="12" />
              <use href="#arrow-right-sign" x="12" y="-81" />
            </g>
            <g>
              <path fill="#000" d="M1205 80h178v106h-178z" />
              <image
                x="1205"
                y="80"
                width="178"
                height="106"
                href="@/assets/work/alibaba/content/key-screens/window-log-in.png"
              />
            </g>
            <image
              x="1295"
              y="274"
              width="88"
              height="150"
              href="@/assets/work/alibaba/content/key-screens/deploy-short.png"
            />
            <text class="ali-evolution-text-strike">
              <tspan x="972" y="232">Synced</tspan>
              <tspan x="972" dy="18">Folder</tspan>
              <tspan x="972" y="304">Sync</tspan>
              <tspan x="972" dy="18">Component</tspan>
              <tspan x="972" dy="18">Package</tspan>
            </text>
            <text class="ali-evolution-text-body">
              <tspan x="1092" y="232">Local</tspan>
              <tspan x="1092" dy="18">Workspace</tspan>
              <tspan x="1092" y="304">Deploy Local</tspan>
              <tspan x="1092" dy="18">Component</tspan>
              <tspan x="1092" dy="18">to Online</tspan>
            </text>

            <text class="ali-evolution-text-title" text-anchor="end">
              <tspan x="1383" y="37">FINAL DESIGN ITERATION (HI-FI)</tspan>
            </text>
          </g>
        </g>
      </svg>
      <svg class="c-1--1" viewBox="0 0 1440 264">
        <path
          fill-opacity="0.253"
          fill="#00baff"
          fill-rule="nonzero"
          d="M0 244h1440V18H0z"
        />
        <g class="anime-tl-low anime-opacity" data-opacity="0.5">
          <image
            x="302"
            y="12"
            width="318"
            height="248"
            href="@/assets/work/alibaba/content/iteration/low-create-comp.png"
          />
          <text class="ali-evolution-text-body">
            <tspan x="219" y="68">Create /</tspan>
            <tspan x="219" dy="18">Import</tspan>
            <tspan x="219" dy="18">Component</tspan>
          </text>
        </g>
        <g class="anime-tl-mid anime-opacity" data-opacity="0.5">
          <image
            x="660"
            y="18"
            width="300"
            height="226"
            href="@/assets/work/alibaba/content/iteration/mid-import-comp.png"
          />
          <text class="ali-evolution-text-body">
            <tspan x="972" y="68">Dedicated</tspan>
            <tspan x="972" dy="18">Import</tspan>
            <tspan x="972" dy="18">Button</tspan>
          </text>
        </g>
        <g class="anime-tl-hi anime-opacity" data-opacity="0.5">
          <path fill="#000" d="M1083 18h300v226h-300z" />
          <image
            x="1083"
            y="18"
            width="300"
            height="226"
            href="@/assets/work/alibaba/content/key-screens/window-workspace.png"
          />
        </g>
      </svg>
      <svg class="c-1--1" viewBox="0 0 1440 286">
        <path fill-opacity="0.25" d="M0 244h1440V18H0z" fill="#00baff" />
        <g class="anime-tl-low anime-opacity" data-opacity="0.5">
          <image
            x="302"
            y="12"
            width="318"
            height="248"
            href="@/assets/work/alibaba/content/iteration/low-preview.png"
          />
          <text class="ali-evolution-text-body">
            <tspan x="219" y="60">Preview /</tspan>
            <tspan x="219" dy="18">Edit / Test</tspan>
            <tspan x="219" dy="18">Component</tspan>
          </text>
        </g>
        <g class="anime-tl-mid anime-opacity" data-opacity="0.5">
          <!-- <image
            opacity="0"
            x="815"
            y="12"
            width="406"
            height="248"
            href="@/assets/work/alibaba/content/iteration/mid-test.png"
            class="anime-tl-mid anime-translate anime-opacity"
            data-dx="164"
            data-dy="0"
            data-opacity="1"
          />
          <image
            opacity="0"
            x="688"
            y="12"
            width="318"
            height="248"
            href="@/assets/work/alibaba/content/iteration/mid-console.png"
            class="anime-tl-mid anime-translate anime-opacity"
            data-dx="37"
            data-dy="0"
            data-opacity="1"
          />-->
          <image
            x="651"
            y="12"
            width="318"
            height="248"
            href="@/assets/work/alibaba/content/iteration/mid-preview.png"
          />
          <text class="ali-evolution-text-body">
            <tspan x="972" y="60">Design</tspan>
            <tspan x="972" dy="18">Component</tspan>
            <tspan x="972" dy="18">Properties</tspan>
            <tspan x="972" dy="18">Panel</tspan>
          </text>
        </g>
        <g class="anime-tl-hi anime-opacity" data-opacity="0.5">
          <g>
            <path fill="#000" d="M1083 18h300v226h-300z" />
            <image
              x="1083"
              y="18"
              width="300"
              height="226"
              href="@/assets/work/alibaba/content/key-screens/window.png"
            />
          </g>
          <text class="ali-evolution-text-body" text-anchor="end">
            <tspan x="1071" y="192">Split Preview</tspan>
            <tspan x="1071" dy="18">&amp; Test Mode</tspan>
          </text>
        </g>
      </svg>
      <!-- <figcaption class="c-x--2 r-3-4 bottom line text-second">
        Redesigned color palette system and UI elements.
      </figcaption>-->
    </figure>
    <div class="section">
      <p class="content">
        Through these 3 iterations, I was constantly Incorporating feedback from
        the product, visual and development team. I also conducted several
        contextual inquiries with some of the users (component developers) and a
        short comparative analysis to gain more insights into the user workflow.
        In general, the design changes in these iterations were mainly driven by
        the following themes:
      </p>
      <ol class="content">
        <li>
          <strong class="highlight">Consistency</strong>: Being a part of a
          larger system, many of my efforts were focused on creating a familar
          workflow that was seamless and adhering to the design guidelines;
        </li>
        <li>
          <strong class="highlight">Affordance</strong>: One major design change
          I made was the mental model switch from a "synced component package"
          to a "local workspace that can be deployed" to better align user
          expectations with the product functions and objectives;
        </li>
        <li>
          <strong class="highlight">Efficiency</strong>: Designing for a
          productivity tool, I added several refinements to accommodate for some
          common alternative workflows observed during contextual inquiries to
          improve efficiency.
        </li>
      </ol>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/styles/base.scss';

.ali-evolution {
  display: grid;
  grid-column: 1 / -1;
  grid-column-gap: $column-gap;
  grid-template-columns: $body-padding - $column-gap repeat(8, 1fr) $body-padding - $column-gap;

  & > .section {
    max-width: 100vw !important;
    padding: 0;
  }
}

.ali-evolution-text-body {
  @extend .text-title;
  font-weight: 500 !important;
  letter-spacing: -0.69;
  fill: $alibaba-theme;
}
.ali-evolution-text-strike {
  @extend .text-title;
  font-weight: 500 !important;
  letter-spacing: -0.69;
  fill: $text-light-second;
  text-decoration: line-through;
}
.ali-evolution-text-title {
  @extend .text-title;
  @extend .large;
  letter-spacing: -0.69;
  fill: $alibaba-tonedown;
}
</style>

<script>
// import anime from 'animejs'

export default {
  name: 'ali-evolution',
  data() {
    return {
      svgLib: {
        // palette: require('@/assets/work/alibaba/content/color-palette.svg')
      },
      figId: 'ali-evolution',
      reveal: 0,
      revealMax: 231,
      revealThreshold: 84,
      dotHovered: false,
      percentObserver: null,
      percentObserving: false,
      percentObserved: null,
      percentOptions: {
        root: null,
        rootMargin: '600px 0px -100px',
        threshold: []
      }
    }
  },
  components: {},
  computed: {
    newOpacity() {
      return this.reveal > this.revealThreshold
        ? 1
        : this.reveal / this.revealThreshold
    },
    oldOpacity() {
      return this.revealMax - this.reveal > this.revealThreshold
        ? 1
        : (this.revealMax - this.reveal) / this.revealThreshold
    }
  },
  methods: {
    handleHoverDot(hovered) {
      // console.log(this.dotHovered)
      this.dotHovered = hovered
    },
    scrollChanged(isVisible) {
      if (isVisible) {
        if (!this.percentObserving) {
          this.percentObserving = true
          this.percentObserver.observe(this.percentObserved)
        }
      } else {
        if (this.percentObserving) {
          this.percentObserving = false
          this.percentObserver.unobserve(this.percentObserved)
        }
      }
    },
    scrollPercent(entries) {
      entries.forEach(entry => {
        if (!this.dotHovered) {
          this.reveal = entry.intersectionRatio * this.revealMax
        }
      })
    }
  },
  mounted() {
    let thresholdSet = []
    for (let i = 0; i <= 1.0; i += 0.01) {
      thresholdSet.push(i)
    }
    this.percentOptions.threshold = thresholdSet
    this.percentObserver = new IntersectionObserver(
      this.scrollPercent,
      this.percentOptions
    )
    this.percentObserved = document.querySelector('#ali-colors-wrapper')
  }
}
</script>
